import { useState } from "react";
import { useTranslation } from "react-i18next";

// Assets
import { Plus } from "@untitled-ui/icons-react";

// API related
import directoryService from "#src/services/endpoint/directory";
import { apiErrorHandler } from "#src/utils/apiErrorHandler";
import { IDirectoryDepartment } from "#src/services/endpoint/directory/types";

// Components
import { ButtonV2 } from "#src/commonV2/Button";
import { EmptyStateV2 } from "#src/commonV2/EmptyState";

type Props = {
  workspaceId: string;
  setDepartments: (departments: IDirectoryDepartment[]) => void;
};

export const EmptyState = (props: Props) => {
  const { workspaceId, setDepartments } = props;
  const { t } = useTranslation("endpoint", { keyPrefix: "directory" });

  // --------------- DATA ---------------

  const [isLoading, setIsLoading] = useState(false);

  // --------------- METHODS ---------------

  const handleCreateDepartment = async () => {
    setIsLoading(true);
    try {
      const res = await directoryService.createDepartment(workspaceId, {
        name: "New Department",
        parent_id: null,
      });
      setDepartments([res]);
    } catch (error) {
      apiErrorHandler(error);
    }
    setIsLoading(false);
  };

  // --------------- RENDER ---------------

  return (
    <div className="flex flex-1 flex-col justify-center items-center text-center">
      <div style={{ maxWidth: 550 }}>
        <EmptyStateV2
          title={t("departments.empty.title")}
          supportingText={`${t("departments.empty.desc1")} ${t("departments.empty.desc2")}`}
          buttons={
            <ButtonV2
              size="lg"
              variant="primary"
              color="brand"
              onClick={handleCreateDepartment}
              pending={isLoading}
            >
              {!isLoading && <Plus className="h-5 w-5 text-white" />}
              <p>{t("departments.empty.btn")}</p>
            </ButtonV2>
          }
        />
      </div>
    </div>
  );
};
